import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable, Provider, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LIB_CONFIG, LibConfig } from '../../lib.config';
import { LoaderService } from '../../services/loader.service';
import { LOADING_INTERCEPTOR_TOKEN } from '../interceptor.token';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private readonly loaderService = inject(LoaderService);
  private readonly libConfig = inject<LibConfig>(LIB_CONFIG);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.libConfig?.showLadeanimation) {
      return next.handle(request);
    }

    const loadingToken = request.context.get(LOADING_INTERCEPTOR_TOKEN);

    switch (loadingToken) {
      case 'termine':
        return this.processAngebotTermine(request, next);
      case 'angebot':
        return this.processAngebote(request, next);
      case 'anbieterfacette':
        return this.processAnbieterFacette(request, next);
      case 'facetten':
        return this.processFacetten(request, next);
      default:
        return next.handle(request);
    }
  }

  processAngebotTermine(request: HttpRequest<unknown>, next: HttpHandler) {
    this.loaderService.setAngebotTermineLoading(true);
    return next
      .handle(request)
      .pipe(finalize(() => this.loaderService.setAngebotTermineLoading(false)));
  }

  processAngebote(request: HttpRequest<unknown>, next: HttpHandler) {
    this.loaderService.setAngeboteLoading(true);
    return next.handle(request).pipe(finalize(() => this.loaderService.setAngeboteLoading(false)));
  }

  processFacetten(request: HttpRequest<unknown>, next: HttpHandler) {
    this.loaderService.setFacettenLoading(true);
    return next.handle(request).pipe(finalize(() => this.loaderService.setFacettenLoading(false)));
  }

  processAnbieterFacette(request: HttpRequest<unknown>, next: HttpHandler) {
    this.loaderService.setAnbieterFacetteLoading(true);
    return next
      .handle(request)
      .pipe(finalize(() => this.loaderService.setAnbieterFacetteLoading(false)));
  }
}

export function provideLoadingInterceptor(): Provider {
  return {
    provide: HTTP_INTERCEPTORS,
    useClass: LoadingInterceptor,
    multi: true,
    deps: [LoaderService, LIB_CONFIG]
  };
}
